jQuery(document).ready(function ($) {
  Fancybox.bind("[data-fancybox]");


  // Home Categories Carousel in Tabs
  $('.home-categories').each(function() {
    var sectionId = $(this).data('identifier');
    var desktop_limit = $(this).data('slides_desktop');
    var laptop_limit = $(this).data('slides_laptop');
    var tab_limit = $(this).data('slides_tab');
    var mobile_limit = $(this).data('slides_mobile');
    console.log('Section ID: ' + sectionId); // Log the unique section ID for each
    // Initialize the carousel using the unique section ID
    var carouselClass = '.' + sectionId; // This will create a unique class selector for each section
    console.log('Initializing carousel for: ' + carouselClass);

    // Example: Initialize OwlCarousel for each section
    $(carouselClass).owlCarousel({
        dots: true,
        loop: true,
        autoplay: true,
        slideSpeed: 2000,
        margin: 25,
        responsiveClass: true,
        nav: true,
        autoplayHoverPause: true,
        navText: ["<i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>", "<i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>"],
        responsive: {
            0: {
                items: mobile_limit,
            },
            900: {
                items: tab_limit,
            },
    
            1000: {
                items: laptop_limit,
            },
    
            1200: {
                items: desktop_limit,
            }
        }
    });

    
  });
  $('.carouselfour').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        dots: true,
        autoplay: true,
        onInitialized: counter, //When the plugin has initialized.
        onTranslated: counter, //When the translation of the stage has 
        navText: [
            '<i class="bi bi-chevron-left"></i>',
            '<i class="bi bi-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 4
            }
        }
    });

    $('.carouselThree').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        dots: true,
        autoplay: true,
        onInitialized: counter, //When the plugin has initialized.
        onTranslated: counter, //When the translation of the stage has 
        navText: [
            '<i class="bi bi-chevron-left"></i>',
            '<i class="bi bi-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 3
            }
        }
    });





  
});